import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '../lib/utils'

// The Parsley wordmark — "Parsley" set in Fraunces (font-brand), the brand's serif voice.
// Semibold weight + tight tracking match the header lockup (see Navbar). `tone` picks the
// ink; `size` drives the type scale. The name is the mark itself, so it is never translated.
const wordmarkVariants = cva('font-brand font-semibold leading-none tracking-[-0.015em]', {
  variants: {
    tone: {
      'dark-green': 'text-brand-green-dark',
      green: 'text-brand-green',
      white: 'text-white',
      // Inherit the surrounding text color — for placing the wordmark on arbitrary surfaces.
      current: 'text-current'
    },
    // Fixed px (not rem) so the wordmark doesn't scale with the app's root font-size clamp.
    size: {
      sm: 'text-[18px]',
      md: 'text-[22px]',
      lg: 'text-[30px]',
      xl: 'text-[48px]'
    }
  },
  defaultVariants: {
    tone: 'dark-green',
    size: 'md'
  }
})

export interface ParsleyWordmarkProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof wordmarkVariants> {}

export const ParsleyWordmark = React.forwardRef<HTMLSpanElement, ParsleyWordmarkProps>(({ className, tone, size, ...props }, ref) => (
  <span ref={ref} className={cn(wordmarkVariants({ tone, size }), className)} {...props}>
    Parsley
  </span>
))
ParsleyWordmark.displayName = 'ParsleyWordmark'

export { wordmarkVariants }
